import { notImplementedFunction } from '../defaultFillers';
import { IUserDictionaryContext } from './UserDictionaryTypes';

export const defaultUserDictionaryContext: IUserDictionaryContext = {
    addIdsToDictionary: notImplementedFunction,
    addUsersToDictionary: notImplementedFunction,
    updateUserInDictionary: notImplementedFunction,
    getUser: notImplementedFunction,
};
